<template>
    
    <ul class="assunto-list" style="padding-top: 0px; padding-bottom: 0px; margin-top: 0px; margin-bottom: 0px;">
        <li v-for="assunto in assuntos" :key="assunto.id" class="assunto-item" style="padding-top: 0px; padding-bottom: 0px; margin-top: 0px; margin-bottom: 0px;">
            <div class="assunto-info row" style="padding-top: 0px; padding-bottom: 0px; margin-top: 0px; margin-bottom: 0px;">
                <div class="assunto-content col-12" style="padding-top: 0px; padding-bottom: 0px; margin-top: 0px; margin-bottom: 0px;" @click="emitPegaAssunto(assunto.id, assunto.descricao)">
                    <span @click="toggleVisibility(assunto.id)">
                        <span v-html="pegarSetasHTML(assunto.id)" style="padding: 0px; margin: 0px; vertical-align: middle;"></span>
                        <img :src='BASE_URL+"imagens/icons/assuntos_directory.png"' v-if="nivel==0" />
                        <img :src='BASE_URL+"imagens/icons/assuntos_directory_file.png"' v-else />
                        
                        {{ assunto.descricao }}
                    </span>
                </div>
            </div>
            <!-- Renderizar subassuntos se existirem -->
            <ProcessoAssuntoArvoreComponent v-if="isVisible(assunto.id) && assunto.children && assunto.children.length" 
            :assuntos="assunto.children" :nivel="1" @addSubassunto="emitPegaAssunto" />
        </li>
    </ul>  
    
    
    </template>
      
    <script>
    import { ref } from 'vue';
    
    export default {
        name: 'ProcessoAssuntoArvoreComponent',
        data() {
            return {
                visibleStates: {},
                BASE_URL: window.Laravel.baseUrl,
            };
            
        },
        props: {
            assuntos: Array,
            nivel: Number,
        },
        setup(props) {
            const visibleStates = ref({});
    
            function toggleVisibility(id) {
                if (visibleStates.value[id] === undefined) {
                    visibleStates.value[id] = true;
                } else {
                    visibleStates.value[id] = !visibleStates.value[id];
                }
            }
    
            function isVisible(id) {
                return !!visibleStates.value[id];
            }
            return { toggleVisibility, isVisible };
        },
    
        methods: {
            pegarSetasHTML(id) {
                return this.isVisible(id) 
                    ? '<span class="material-icons">expand_more</span>' 
                    : '<span class="material-icons">chevron_right</span>';
            },

            emitPegaAssunto(assuntoId, assuntoDescricao) {
                this.$emit('addSubassunto', assuntoId, assuntoDescricao);
            },
    
        },
        mounted(){
            
        }
    
    };
    </script>
      
    <style scoped>
    .assunto-list {
        padding-left: 20px; /* Indentação para níveis filhos */
        list-style: none; /* Remove marcadores de lista */
        margin: 0;
    }
    
    .assunto-item {
        padding: 1px;
        margin: 1px;
        font-style: italic;
    }
    
    .assunto-item:hover{
        background-color: #f0f0f0; /* Cinza leve para ao passar o mouse na macro área */
        text-decoration: underline;
    }
    
    
    .assunto-info {
        padding: 1px;
        margin: 1px;
    }
    
    .assunto-info:hover {
        background-color: #e0e0e0; /* Cinza mais forte ao passar o mouse em cada item */
        cursor: pointer;
        text-decoration: underline;
    }

    span{
        font-size: 10px;
    }
    </style>
    
